import { render, staticRenderFns } from "./policyDailog.vue?vue&type=template&id=e06bc91a&scoped=true&"
import script from "./policyDailog.vue?vue&type=script&lang=js&"
export * from "./policyDailog.vue?vue&type=script&lang=js&"
import style0 from "./policyDailog.vue?vue&type=style&index=0&id=e06bc91a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e06bc91a",
  null
  
)

export default component.exports